import { ApplicationSearchConstants } from "../../../tabs/applications/application-search/application-search-constants";
export var SearchContainerHeight;
(function (SearchContainerHeight) {
    // the first list of height settings are in px
    SearchContainerHeight[SearchContainerHeight["Bays"] = 35] = "Bays";
    SearchContainerHeight[SearchContainerHeight["POIs"] = 35] = "POIs";
    SearchContainerHeight[SearchContainerHeight["Streets"] = 35] = "Streets";
    SearchContainerHeight[SearchContainerHeight["Cemetery"] = 35] = "Cemetery";
    SearchContainerHeight[SearchContainerHeight["Simple"] = 55] = "Simple";
    SearchContainerHeight[SearchContainerHeight["SingleLine"] = 323] = "SingleLine";
    SearchContainerHeight[SearchContainerHeight["Extended"] = 500] = "Extended";
    SearchContainerHeight[SearchContainerHeight["Max"] = 560] = "Max";
    SearchContainerHeight[SearchContainerHeight["Map"] = 612] = "Map";
    // the following two settings are set via custom css
    SearchContainerHeight[SearchContainerHeight["PropertiesWithoutMap"] = 1] = "PropertiesWithoutMap";
    SearchContainerHeight[SearchContainerHeight["PropertiesMap"] = 2] = "PropertiesMap";
    SearchContainerHeight[SearchContainerHeight["CemeteryLocationMap"] = 3] = "CemeteryLocationMap";
    SearchContainerHeight[SearchContainerHeight["CemeterySimple"] = 4] = "CemeterySimple";
    SearchContainerHeight[SearchContainerHeight["CemeteryLocationWithoutMap"] = 5] = "CemeteryLocationWithoutMap";
    SearchContainerHeight[SearchContainerHeight["CemeteryApplicationMap"] = 6] = "CemeteryApplicationMap";
    SearchContainerHeight[SearchContainerHeight["GraveLocationMap"] = 7] = "GraveLocationMap";
    SearchContainerHeight[SearchContainerHeight["BaysLocationMap"] = 8] = "BaysLocationMap";
    SearchContainerHeight[SearchContainerHeight["POILocationMap"] = 8] = "POILocationMap";
    SearchContainerHeight[SearchContainerHeight["StreetsLocationMap"] = 8] = "StreetsLocationMap";
})(SearchContainerHeight || (SearchContainerHeight = {}));
// This serves as the strategy interface , since javascript has no comprehension of interfaces for providers
export class AflaModuleStrategyService {
    dynamicTitle = {
        Applications: "Applications",
        Application: "Application",
        CreateApplicationLinkText: "Create Application",
        CreateApplicationTitle: "Create Application",
        ViewApplicationTitle: "View Application",
    };
    constructor() { }
    // "has grave" parameter is required for CMS
    static buildModuleIDFilter(moduleID, withGrave) {
        return (`moduleID eq ${moduleID}` +
            ` and deleted eq false` +
            (withGrave ? ` and ${ApplicationSearchConstants.GRAVES}/any()` : ""));
    }
    // TODO: currently only available for TPAMS - rest to follow later
    static showCompleteApplications() {
        return "eLodgementComplete eq true";
    }
    static successMessage(jobId) {
        return `Application ${jobId} created successfully`;
    }
    init() {
        this.initializeSettingsComponents();
        this.initializeViewApplicationComponents();
        this.initializeCreateApplicationComponents();
        this.initializeAdvancedApplicationSearchComponents();
        this.initializeSearchOptionsLookup();
        this.initializeSearchQueryLookup();
        this.initializeApplicationTableColumnMap();
        this.initializeAdditionalSearchLookup();
        this.initializeDateSearchOptions();
        this.initializeStatusSearchOptions();
        this.initializeBuildingUseSearchOptions();
        this.initializeGroupSearchOptions();
        this.initializeApplicationSummaryColumnsMap();
    }
}
